import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { Video, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getYouTubeId(url) {
  const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  return match ? match[1] : null;
}

export default function SermonsPage() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [sermons, setSermons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { if (!authLoading && !user) navigate("/login"); }, [user, authLoading, navigate]);

  useEffect(() => {
    axios.get(`${API}/sermons`).then(res => setSermons(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (authLoading || !user) return null;

  return (
    <div data-testid="sermons-page">
      <section className="bg-[#1C2E4A] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#C8A97E] font-semibold mb-3">Watch & Listen</p>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-white">Sermons</h1>
        </div>
      </section>
      <section className="py-12 md:py-16 bg-white min-h-[50vh]">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          {loading ? (
            <div className="text-center py-20"><Loader2 className="w-6 h-6 text-[#C8A97E] animate-spin mx-auto" /></div>
          ) : sermons.length === 0 ? (
            <div className="text-center py-20">
              <Video className="w-12 h-12 text-[#E5E2DC] mx-auto mb-4" />
              <p className="text-[#595959]">No sermons available yet. Check back soon.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {sermons.map((s) => {
                const videoId = getYouTubeId(s.youtube_url);
                return (
                  <div key={s.id} data-testid={`sermon-${s.id}`} className="bg-[#FAF9F6] rounded-xl border border-[#E5E2DC] overflow-hidden">
                    {videoId ? (
                      <div className="aspect-video">
                        <iframe
                          src={`https://www.youtube.com/embed/${videoId}`}
                          title={s.title}
                          className="w-full h-full"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        />
                      </div>
                    ) : (
                      <div className="aspect-video bg-[#1C2E4A]/5 flex items-center justify-center">
                        <Video className="w-8 h-8 text-[#595959]" />
                      </div>
                    )}
                    <div className="p-5">
                      <h3 className="font-serif text-base font-semibold text-[#1C2E4A] mb-1">{s.title}</h3>
                      {s.description && <p className="text-xs text-[#595959]">{s.description}</p>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
